// Auto-refactored from translations.js on 2026-08-19
// Locale: ja

const ja = {
  wieMoeglich: { question: 'なぜそれが可能なのか？', answer: '私たちはバリューチェーンを再考しました。' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'STIG ROCKの道',
    fazit: '短縮されたサプライチェーンにより、最大のコスト項目が不要になります。',
    fazitBigPre: 'これにより可能になる値引きは最大',
    fazitBigValue: '80%',
    steps: [ '鉱山', 'カット工房', '鑑定・認証', 'エンドカスタマー' ]
  },
  nav: { language: '言語', contact: 'お問い合わせ' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: '唯一無二の機会',
    subtitle: '未来を見据えた資産形成を。',
    description: 'STIG ROCKは、天然ダイヤモンド、持続可能な資産形成、そして唯一無二のコミュニティへのアクセスを提供する国際的なプラットフォームです。',
    scroll: 'スクロールして詳細を見る'
  },
  disclaimer: {
    overline: '法的通知',
    title: 'Disclaimer',
    paragraphs: [
      '本プレゼンテーションは情報提供のみを目的としており、財務、投資、または税務に関するアドバイスを構成するものではありません。',
      'STIG ROCKは金融商品ではなく、実物資産としての天然のDiamondを扱うものです。',
      '価値の推移、利益、または収益について保証するものではありません。過去の実績は将来の結果を保証するものではありません。',
      '報酬に関連して示されるすべての計算はあくまで例示であり、同様に保証を構成するものではありません。'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ '構造の上に', '築かれた' ],
    body: 'STIG Groupは、透明性、責任、そして長期的な価値に基づいて構築された国際的なコンツェルンです。すべてのブランド、プロジェクト、パートナーシップは、妥協も例外もない独自の基準に従っています。',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ '構造の上に', '築かれた' ],
        body: 'STIG Groupは、透明性、責任、そして長期的な価値に基づいて構築された国際的なコンツェルンです。すべてのブランド、プロジェクト、パートナーシップは、妥協も例外もない独自の基準に従っています。'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ '独占的な', 'Diamondの世界' ],
        body: 'STIG ROCKは、高品質なGIA認定Diamondと透明性の高い構造、そして独占的な顧客体験を融合させたSTIG Groupのモダンなコンセプトです。明確なソリューションプラン、プロフェッショナルな手続き、そして国際的な展開を提供します。'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ '国際的な', 'Diamond貿易' ],
        body: 'STIG InternationalはSTIG Groupの一員であり、GIA認定Diamondの国際取引を専門としています。品質、信頼、そしてグローバルなパートナーシップを備えた近代的な取引構造に焦点を当てています。'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ '採掘現場からの', '責任' ],
        body: 'Ethical Minesは、責任ある採掘、追跡可能な起源、そして紛争フリーのDiamondを象徴しています。鉱山から市場まで、サプライチェーン全体にわたる透明性、誠実さ、そして長期的な責任のための完全な文書化を行っています。'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'ダイヤモンド',
    stigDrawback: '実物の価値保存手段',
    overline: '可能性',
    title: '資産形成の可能性',
    subtitle: '従来の投資方法との比較。',
    items: [
      { tag: 'Trading', name: 'FX または 仮想通貨', drawback: '極めて投機的、予測不能、複雑' },
      { tag: '株式', name: '証券取引', drawback: '変動リスク、必要な知識、時間的負担' },
      { tag: '仮想通貨', name: '取引', drawback: 'ボラティリティ、規制リスク、セキュリティの脆弱性' }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: '過小評価されているチャンス',
    body: 'Diamondは何年もの間、最も価値が安定し、チャンスに満ちた投資形態の一つとされてきましたが、これまでその可能性を活用できたのはごく一部の人々だけでした。',
    callout: '私たちのSTIG ROCKにより、初めてすべての人にこの並外れた可能性への道を開きます。'
  },
  wertentwicklung: {
    overline: '価格推移 1995 — 2025',
    title: '価値の歴史。',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: '1995年 — 2025年の推移'
  },
  hauptgruende: {
    overline: '主な理由',
    title: 'Diamondを選ぶ6つの理由',
    lead: 'Diamondは、通貨や金融システムに依存せずに存在する実物資産であり、何世紀にもわたってその価値を維持してきました。',
    items: [
      { n: '01', title: '危機に強い価値の安定性', body: '実物資産の保証。通貨や金融システムの影響を受けません。' },
      { n: '02', title: '究極のモビリティ', body: '小型で軽量、保管や持ち運びが容易です。' },
      { n: '03', title: '分散投資と希少性', body: '供給不足と自然界の限界による希少性。' },
      { n: '04', title: '長期的な成長', body: '1995年以来 +185%。' },
      { n: '05', title: '透明性と独占性', body: '保証としての4C：Carat, Color, Clarity, Cut。' },
      { n: '06', title: '王室の準備資産', body: '王室でさえ、資産の備蓄としてDiamondを利用しています。' }
    ]
  },
  markt: {
    overline: '市場規模',
    title: '99 — 108 Mrd. USD',
    sub: '2025年の取引量',
    forecast: '2032年 / 2034年までの予測：緩やかな成長（年率約4 – 5 %）により約 140 – 168 Mrd. USD。',
    source: '出典: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — 革新',
    title: '一つの革新。世界で初めての試み。',
    body: 'STIG ROCKは、ダイヤモンド市場において価値上昇に加え、不労所得を得ることを可能にした世界初のプラットフォームです。',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      '登録番号 DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: '企業について',
    titleLines: [ '国際的な構造', '明確なビジョン' ],
    body: 'STIG ROCKは、信頼、安全、そして長期的な構造に焦点を当て、ダイヤモンド市場をより透明で、現代的、かつ顧客中心のものにするために設立されました。'
  },
  sicherheit: {
    overline: '品質と安全性',
    title: 'Gemological Institute of America',
    body: 'あなたのDiamondのための認定された専門知識。GIAは、長年の経験と最高の精度で各石を評価し、当社とお客様に信頼できる鑑定書を提供します。',
    transparency: 'すべてのDiamondは最高品質基準を満たし、著名な機関によって検査および認定されています。各石は唯一無二であり、個別の証明書が発行されます。'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: '独自の製品革新',
    sub: '6つの段階的な Solution Pläne — $1K から $100K+ まで、月ごとおよび全期間にわたって割引率が上昇します。',
    recommended: '人気',
    oneYear: '1年',
    rowLabels: {
      delivery: '納期',
      price: '製品価格',
      carat: 'ct',
      monthly: '割引 (月)',
      totalDiscount: '割引 (合計)',
      duration: '期間'
    },
    headers: {
      plan: 'プラン',
      from: 'から',
      carat: 'ct',
      monthly: '割引 / 月',
      total: '割引合計',
      duration: '期間'
    },
    duration: '1年',
    footnote: 'すべての価格表示は保証されるものではなく、品質、需要、および現在の市場動向に依存します。Solution プランは2年間も選択可能です。'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + VIP-Paket',
    title: 'VIP-Paketでさらなる特典を',
    sub: 'Solution PlanとVIP-Paketを組み合わせることで、最大3%の追加割引特典をご利用いただけます。総合割引率を高め、さらに魅力的な条件を確保できます。',
    rowLabels: {
      delivery: '納期',
      price: '製品価格',
      carat: 'ct',
      monthly: '割引 (月)',
      totalDiscount: '割引 (合計)',
      vip1: 'VIP-Paket 1 (+1%)',
      vip2: 'VIP-Paket 2 (+2%)',
      vip3: 'VIP-Paket 3 (+3%)'
    },
    footnote: 'すべての価格表示は保証されるものではなく、品質、需要、および現在の市場動向に依存します。'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'VIP-Paketでさらなる特典を',
    sub: 'Solution PlanとVIP-Paketを組み合わせることで、最大3%の追加割引特典をご利用いただけます。総合割引率を高め、さらに魅力的な条件を確保できます。',
    options: [
      { key: 'deliver', title: 'VIP-Paketでさらなる特典を', body: 'DS-Plan* の価格に応じた Diamond (ct)' },
      { key: 'sellToUs', title: '当社に売却する', body: '支払った購入価格でDiamondを当社に買い戻し依頼することができます。' },
      { key: 'sellThirdParty', title: '第三者に売却する', body: 'Diamondを第三者に転売することも可能です。' }
    ],
    footnote: '*DS-Plan は Solution プランを指します。'
  },
  tradWeg: {
    overline: '伝統的な取引',
    title: '伝統的な流通経路',
    sub: 'Diamondがエンドユーザーに届くまでに、中間業者、卸売業者、小売業者を経て、採掘時の原石価格に対して大幅な利益幅が上乗せされます。',
    steps: [
      { title: '鉱山', subtitle: 'Diamond原石' },
      { title: '中間業者', subtitle: '原石の買い付け' },
      { title: '研磨工場', subtitle: '宝石用Diamondへのカット' },
      { title: '認定', subtitle: 'GIAなどの公認機関による鑑定' },
      { title: 'Diamond取引所', subtitle: '卸売業者への販売' },
      { title: '卸売', subtitle: '小売業者への販売' },
      { title: '小売', subtitle: '例：宝石店' },
      { title: 'エンドユーザー', subtitle: 'Diamondの購入' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-Pakete',
    sub: '契約したすべての Solution プランに対して12ヶ月間有効です。VIP-Paket に応じて +1% から +3% の追加割引が適用されます。',
    cardKicker: '追加適用 – すべての',
    cardKicker2: 'Solution プランに',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: '割引が貯蓄に変わる',
      body: '毎月の負担ではなく、毎月の節約。割引から貯蓄が生まれ、それが普段自分のポケットから支払っている毎月の支出を補います。',
      line1Label: 'DS-Plan 開始',
      line1Value: '$5.000',
      line2Label: '月次割引',
      line2Value: '3%',
      line3Label: 'VIP-Paket 3',
      line3Value: '+3%',
      resultLabel: '月間節約額',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'なぜ可能なのか？',
    title: 'バリューチェーンを再定義しました。',
    traditionalTitle: '伝統的な流通経路',
    traditionalSteps: [
      '鉱山 — 原石',
      '中間業者 — 買い付け',
      '研磨工場 — カット',
      '認定 (GIA)',
      'Diamond取引所 — 卸売',
      '卸売 → 小売',
      '宝石店 → エンドユーザー'
    ],
    traditionalNote: 'Diamondがエンドユーザーに届くまでに、中間取引、卸売、小売を通じて大幅な価格差が生じます。',
    stigTitle: 'STIG ROCK の手法',
    stigSteps: [ '直接購入 — 鉱山からの原石', '提携先による研磨と鑑定', 'エンドユーザーおよびB2B顧客への販売', '年間最大4回の取引サイクル' ],
    stigNote: '私たちはこの循環を打破し、中間マージンを割引としてお客様に還元します。DS-Plan 期間中に最大4回の取引サイクルが行われます。'
  },
  optionen: {
    overline: 'あなたの選択肢',
    title: 'Solution プラン終了後',
    items: [
      { title: '配送を希望する', body: 'DS-Plan の価格で Diamond (ct) を受け取る。' },
      { title: '当社に売却する', body: '支払った購入価格での買い戻し。' },
      { title: '第三者に売却する', body: '自由市場でDiamondを売却する。' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution プラン — 独自の製品革新',
    title: 'シンプルなステップ',
    steps: [
      { n: '01', icon: 'signup', title: '登録', body: '紹介者に連絡して、無料アカウントを作成しましょう！' },
      { n: '02', icon: 'cart', title: '製品の購入', body: '$ 250,- から開始可能' },
      { n: '03', icon: 'discount', title: '割引を受け取る', body: '毎月の割引還元を受け取ります。' }
    ]
  },
  business: {
    overline: 'ボーナスの種類',
    title: '最もシンプルで公平な方法。',
    sub: 'ビジネス構築を成功させるための5つのボーナス。 ',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'レベル3まで、キャリアランク Pearl / Ruby から適用。'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Sapphire 以上 — 深さ無制限。'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Infinity Bonus に対して適用 – レベル5まで · 資格要件なし。'
      },
      { name: 'World Pools', icon: 'world', value: '3%', desc: '世界売上の3つのプール。' },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Diamond (ct) による一回限りのボーナス。'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'このボーナスは、第3レベルまでに新しく契約されたすべての Solution プランに対して支払われます。非常に低い要件で各レベルのロックを解除できます。',
    total: '最大 18% の Unilevel Bonus',
    levels: [
      { level: 'レベル 1', value: '10%', qual: '最初から', coin: 'image84.png', badge: 'Partner' },
      {
        level: 'レベル 2',
        value: '5%',
        qual: 'キャリアランク Pearl 以上',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'レベル 3',
        value: '3%',
        qual: 'キャリアランク Ruby 以上',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'キャリアランク Sapphire から Infinity Bonus プランの対象となります。3% のボーナスから始まり、ランクが上がるごとにパーセンテージが加算されます。チーム内のパートナーも資格を持っている場合は、ランク間の差額を受け取ります。',
    exampleTitle: '例',
    exampleRows: [
      { label: 'あなたが Blue Diamond の場合', value: '12%' },
      { label: 'パートナーが Sapphire の場合', value: '3%' }
    ],
    exampleResult: { label: 'あなたの Infinity Bonus', value: '9%' },
    totalNote: 'チーム内のすべての Solution プランに対して、深さ無制限で合計最大 24% の Infinity Bonus が適用されます。',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'このボーナスにより、チームの成功から利益を得ることができます。パートナーの Infinity Bonus に対して 5% の Matching Bonus を、チームの第5階層まで受け取れます。',
    note: 'チーム内のすべての Infinity Bonus 支払いに対して – 第5レベルまで。最初から – 資格要件なし。',
    levels: [
      { level: 'レベル 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: '合計最大',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '世界売上の 3% が 3つの異なるプールに均等に分配されます。特定のキャリアランクに到達することで、各プールへの参加資格が得られます。',
    forever: '一度到達すれば – 永久に参加！',
    pools: [
      { key: 'p1', label: 'プール 1', value: '1%', qual: 'Blue Diamond 以上' },
      { key: 'p2', label: 'プール 2', value: '1%', qual: 'Purple Diamond 以上' },
      { key: 'p3', label: 'プール 3', value: '1%', qual: 'Double Diamond Elite 以上' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: '合計',
    totalValue: '3%',
    totalSuffix: '世界売上に対して'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'キャリアランク Diamond 以上で Rang Bonus を受け取れます。これは Diamond (ct) で支払われる一回限りのボーナスです。',
    highlight: 'Diamond (ct) 総額',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: 'キャリアランク',
    sub: '各キャリアランクの達成には、歴史的総売上 (HG) がカウントされます。Sapphire ランク以降は、売上が複数のチームに分散されている必要があります。Ruby 以上を達成するには、Solution プランを持つ少なくとも2人の直紹介パートナーが必要です。',
    forever: '一度到達すれば – 永久に確定！',
    footnote: 'HV = 歴史的総売上。',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: '私たちと一緒にスタートしましょう',
    title: 'その時は、今です。',
    body: 'このビジネスモデルは新たな基準を打ち立て、長期的かつ持続可能な成功のために必要なすべての要素を兼ね備えています。今すぐ登録し、あなたの Solution プランを選択して、この唯一無二のビジネスチャンスを掴んでください。',
    hint: 'あなたをこのプレゼンテーションに招待した方に連絡してください。登録リンクをお持ちです。',
    formName: '氏名',
    formEmail: 'メールアドレス',
    formPhone: '電話番号',
    formSubmit: '問い合わせる',
    success: 'ありがとうございます。個人的に、かつ機密を保持してご連絡いたします。',
    callCta: '電話する',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: '法的通知および Disclaimer',
    disclaimer: '本プレゼンテーションは情報提供のみを目的としており、財務、投資、または税務に関するアドバイスを構成するものではありません。STIG ROCKは金融商品ではなく、実物資産としての天然のDiamondを扱うものです。価値の推移、利益、または収益について保証するものではありません。過去の実績は将来の結果を保証するものではありません。報酬に関連して示されるすべての計算はあくまで例示であり、同様に保証を構成するものではありません。内容の変更が行われる場合があります。 — 自由翻訳（公式翻訳ではありません）。',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. All rights reserved.',
    version: 'Version: DS-12-2025 V3'
  },
  misc: { next: '次のセクション' }
};

export default ja;
